import { BrowserRouter, Routes, Route } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import UserContext from "../context/UserContext";
import { useState } from "react";

import Home from "./Home";
import InstrucaoCalibragem from "./InstrucaoCalibragem";
import Calibragem from "./Calibragem";
import ComAnel from "./ComAnel";
import InstrucaoSemAnel from "./InstrucaoSemAnel";
import SemAnel from "./SemAnel";

import img1 from "../imgs/img1.png";
import img2 from "../imgs/img2.png";
import img3 from "../imgs/img3.png";
import img4 from "../imgs/img4.png";

export default function App() {
  const [tamCartao, setTamCartao] = useState("160");
  const umCm = tamCartao / 5.4;

  return (
    <>
      <Img1 src={img1}></Img1>
      <Img2 src={img2}></Img2>
      <Img3 src={img3}></Img3>
      <Img4 src={img4}></Img4>
      <BrowserRouter>
        <GlobalStyled />
        <UserContext.Provider value={{ tamCartao, setTamCartao, umCm }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/instrucao-calibragem"
              element={<InstrucaoCalibragem />}
            />
            <Route path="/calibragem" element={<Calibragem />} />
            <Route path="/medicao-com-anel" element={<ComAnel />} />

            <Route path="/instrucao-sem-anel" element={<InstrucaoSemAnel />} />
            <Route path="/medicao-sem-anel" element={<SemAnel />} />
          </Routes>
        </UserContext.Provider>
      </BrowserRouter>
    </>
  );
}

const GlobalStyled = createGlobalStyle`
    ${reset}
    
    *, body {
        box-sizing: border-box;
        cursor: default;
        font-family: 'Merriweather', serif;
    a {
        text-decoration: none;
    }
    }
`;

const Img1 = styled.img`
  position: fixed;
  z-index: -1;
  top: 0;
  right: 0;
  width: 80%;

  @media (min-width: 1300px) {
    width: 30%;
  }
`;
const Img2 = styled.img`
  position: fixed;
  z-index: -1;
  bottom: 0;
  left: 0;
  width: 80%;

  @media (min-width: 1300px) {
    width: 40%;
  }
`;
const Img3 = styled.img`
  position: fixed;
  z-index: -1;
  bottom: 0;
  right: 0;
  width: 55%;

  @media (min-width: 1300px) {
    width: 25%;
  }
`;

const Img4 = styled.img`
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  width: 55%;

  @media (min-width: 1300px) {
    width: 35%;
  }
`;
